import React, {useContext, useEffect, useState, Fragment} from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import {Button} from "react-bootstrap";
import {BaseUrl} from "../../../contexts/baseUrl/baseUrl";
import Layout from "../../../components/sales/layout/layout";
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import {toast} from "react-toastify";

const Transaction = ({
    match,
    transactionListing,
    transaction = []
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await transactionListing(match?.params?.wallet_id,1)
            setIsLoading(false)
        })()
    }, [])

    const headers = [
        'Amount',
        'Description',
        'Operation',
        'Direction',
        'Service',
        'Created At'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await transactionListing(match?.params?.wallet_id,val.selected + 1);
        setIsLoading(false);
    };

    useEffect(() => {
        if (transaction &&
            transaction?.resultSets !== undefined && transaction?.resultSets.length > 0) {
            const tableData = ['id', 'amount', 'description', 'operation', 'direction', 'service', 'created_at'];
            const data = transaction?.resultSets.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        {[key]: element[key]}
                    )),
                    {},
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(transaction.total / transaction.per_page));
        }
    }, [transaction])

    const downlaodTransaction = async(walletId) => {
          if(walletId) {
            setIsLoading(true);
            const paylaod = {
                'wallet_id': walletId
            }
            const url = `${Config.wallet.downlaodWalletTransaction}`;
            const res = await axios.post(url,paylaod);
            if(res && res?.data?.response) { 
                setIsLoading(false);
                window.open(res?.data?.response.data, '_self');
            } else {
                setIsLoading(false);
                toast.error('Something went wrong.');
            }
          }                                                                                                                 
    }

    const headerBtns = () => {
        return (
          <div className="Pm-btn pm-btn-align">
            
          <Fragment>
          
            <Button
              className="btn btn-transparent d-md-inline-block "
              onClick={() => downlaodTransaction(match?.params?.wallet_id)}
            >
              {localization.downloadTransactions}
            </Button>
          </Fragment>
         </div>
        )
    }   

    return (
        <>
            <Layout
                title={localization.transaction}
                isLoading={isLoading}
                isGoback={true}
                Buttons={headerBtns}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={transaction && transaction?.resultSets}
                    srNo={transaction?.from}
                />
            </Layout>
        </>
    )
}

export default Transaction

